module.exports = {
  content: ['./public/**/*.html', './src/**/*.vue', './Views/**/*.cshtml'],
  options: {
    safelist: [
      'md:col-span-1',
      'md:col-span-2',
      'md:col-span-3',
      'md:col-span-4',
      'md:col-span-5',
      'md:col-span-6',
      'md:col-span-7',
      'md:col-span-8',
      'md:col-span-9',
      'md:col-span-10',
      'md:col-span-11',
      'md:col-span-12',
    ],
  },
  theme: {
    container: {
      center: true,
    },
    borderRadius: {
      none: '0px',
      xs: '0.25rem', // 4px
      sm: '0.625rem', // 10px
      smd: '0.938rem', // 15px
      DEFAULT: '1.25rem', // 20px
      md: '1.75rem', // 28px
      lg: '1.875rem', // 30px
      full: '9999px',
    },
    boxShadow: {
      xs: '0px 0px 60px rgba(0, 0, 0, 0.05)',
      sm: '1px 2px 8px rgba(0, 0, 0, 0.35)',
      md: '0 4px 20px rgba(54, 25, 5, 0.12)',
      DEFAULT: '0 0 16px rgba(0, 0, 0, 0.25)',
      inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
      none: 'none',
      form: '0 4px 20px rgba(54, 25, 5, 0.1)',
      form_focus: '0 4px 25px rgba(54, 25, 5, 0.2)',
    },
    colors: {
      black: '#1D1D1D',
      white: '#FFFFFF',
      transparent: 'transparent',
      current: 'currentColor',
      primary: {
        alpha: 'var(--color-primary-alpha)',
        bravo: 'var(--color-primary-bravo)',
        bravo_hover: 'var(--color-primary-bravo-hover)',
        charlie: 'var(--color-primary-charlie)',
        delta: 'var(--color-primary-delta)',
      },
      secondary: {
        alpha: 'var(--color-secondary-alpha)',
        bravo: 'var(--color-secondary-bravo)',
        charlie: 'var(--color-secondary-charlie)',
        delta: 'var(--color-secondary-delta)',
      },

      yellow: '#FEC901',
      gray: {
        50: '#F5F0EC',
        75: '#D7CBC3',
        100: '#BBBBBB',
        200: '#A5A5A4',
        300: '#8E8E8D',
        400: '#61615F',
        500: '#4A4A49',
        600: '#343432',
        700: '#1D1D1D',
      },
      success: '#198754',
      danger: '#ef575d',
    },
    fontFamily: {
      sans: ['Cera Pro', 'Arial', 'sans-serif'],
      playfair: ['Playfair Display', 'Arial', 'sans-serif'],
    },
    fontSize: {
      xs: ['0.75rem'], // 12px
      sm: ['0.875rem'], // 14px
      '2sm': ['0.938rem'], // 15px
      base: ['1rem'], // 16px
      lg: ['1.125rem'], // 18px
      xl: ['1.25rem'], // 20px
      '2xl': ['1.5rem'], // 24px
      '3xl': ['1.75rem'], // 28px
      '4xl': ['1.875rem'], // 30px
      '5xl': ['2.25rem'], // 36px
      '6xl': ['2.5rem'], // 40px
      '7xl': ['2.75rem'], // 44px
      '8xl': ['3.125rem'], // 50px
      '9xl': ['3.75rem'], // 60px
      '10xl': ['6rem'],
      '11xl': ['8rem'],
    },
    screens: {
      xs: '480px',
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
    },
    extend: {
      screens: {
        '2xl': { raw: '(min-width: 1440px)' },
      },
      maxWidth: {
        '2xl': '42rem',
        '3xl': '45rem', // 720px
        '5xl': '60rem', // 960px
        '7xl': '75rem', // 1200px
      },
      lineHeight: {
        none: '1',
        xxs: '1.2',
        xs: '1.25',
        sm: '1.3333333333',
        md: '1.5',
        lg: '1.625',
        xl: '1.7777777778',
        xxl: '2',
        3: '.75rem',
        4: '1rem',
        5: '1.25rem',
        6: '1.5rem',
        7: '1.75rem',
        8: '2rem',
        9: '2.25rem',
        10: '2.5rem',
      },
    },
  },
  plugins: [],
};
